import {gql} from 'apollo-angular';
import {ProfessionPreviewFragment} from "./fragments/ProfessionPreview";

export const GET_PROFESSIONS = gql`
  query GetProfessions($limit: Int!, $offset: Int!) {
    jobs(limit: $limit, offset: $offset) {
      ...professionPreviewFields,
    }
  }
  ${ProfessionPreviewFragment}
`;
